import { IconComponentProps } from '../IconTypes';

const Flag = ({ className }: IconComponentProps) => (
  <svg className={className} fill="none" height="20" viewBox="0 0 18 20" width="18" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M4.58333 2.70817C4.58333 2.132 4.11784 1.6665 3.54167 1.6665C2.96549 1.6665 2.5 2.132 2.5 2.70817V3.74984V13.6457V17.2915C2.5 17.8677 2.96549 18.3332 3.54167 18.3332C4.11784 18.3332 4.58333 17.8677 4.58333 17.2915V13.1248L6.67643 12.6007C8.01432 12.2655 9.43034 12.4217 10.6641 13.0369C12.1029 13.7563 13.7728 13.8442 15.2767 13.2778L16.4063 12.8547C16.8132 12.7017 17.0833 12.3143 17.0833 11.8781V3.8182C17.0833 3.0695 16.2956 2.58122 15.625 2.9165L15.3125 3.07275C13.8053 3.82796 12.0313 3.82796 10.5241 3.07275C9.38151 2.49984 8.06966 2.35661 6.82943 2.66585L4.58333 3.229V2.70817Z"
      fill="#229B70"
    />
  </svg>
);

export default Flag;
